<mat-form-field
  floatLabel="never"
  subscriptSizing="dynamic"
  class="date-range-picker-form-field"
  [ngClass]="{
    'action-filter': isPartOfFilter,
    'error-handle': errorStyleHandleRequired,
    'hide-border': removeBorder,
    'error-border': errorBorder
  }"
>
  <mat-label *ngIf="!dateRangeSelected">Enter a date range</mat-label>
  <mat-date-range-input
    [formGroup]="range"
    [rangePicker]="picker"
    [max]="maxDate"
    [min]="minDate"
    [disabled]="disabled"
  >
    <input
      matStartDate
      formControlName="start"
      placeholder="Start date"
      (blur)="onBlur()"
    />
    <input
      matEndDate
      formControlName="end"
      placeholder="End date"
      (blur)="onBlur()"
    />
  </mat-date-range-input>
  <mat-datepicker-toggle matSuffix [for]="picker">
    <mat-icon
      matDatepickerToggleIcon
      class="custom-calendar-icon"
      title="Calendar"
      svgIcon="calendar-icon"
    >
    </mat-icon>
  </mat-datepicker-toggle>
  <mat-date-range-picker
    #picker
    (opened)="onOpen()"
    [opened]="opened"
    (closed)="onClose()"
  ></mat-date-range-picker>
  <div style="display: none">
    <div class="datepicker-footer" #datepickerFooter>
      <a href="javascript:void(0)" (click)="clear()" #clearButton> Clear </a>
    </div>
  </div>
  <mat-error *ngIf="!datePickerValid('start')">Invalid start date</mat-error>
  <mat-error *ngIf="!datePickerValid('end') || datePickerEndBeforeStart()">
    Invalid end date
  </mat-error>
</mat-form-field>

<!-- Copyright 2021 Google LLC. All Rights Reserved.
    Use of this source code is governed by an MIT-style license that
    can be found in the LICENSE file at http://angular.io/license -->
